module.exports = __webpack_public_path__ + "img/11.3d892a99.png";